import { createRoutine } from 'redux-saga-routines';
import { createAction } from 'redux-actions';
import {
  LIST_EHR_SYNC_ISSUES,
  SYNC_ALL_LEADS,
  SYNC_LEAD_BY_ID,
  LIST_EHR_SYNC_INFO,
  MODAL_SET_CLOSED,
  MODAL_OPEN_SET_NOT_FOUND,
  MODAL_SELECT_ITEM,
  MODAL_INPUT_EHR_PATIENT_ID,
  MODAL_TRIGGER_NOT_FOUND,
  MODAL_CLEAN,
  SYNC_LAST_UPDATED,
  SYNC_MANUAL_ALL,
  SYNC_MANUAL_ITEMS,
  SYNC_MANUAL_ITEMS_FINISH,
} from './types';

export const listEhrSyncIssues = createRoutine(LIST_EHR_SYNC_ISSUES);
export const listEhrSyncInfo = createRoutine(LIST_EHR_SYNC_INFO);
export const syncAllLeads = createRoutine(SYNC_ALL_LEADS);
export const syncLeadById = createRoutine(SYNC_LEAD_BY_ID);

export const modalOpenSetNotFound = createAction(MODAL_OPEN_SET_NOT_FOUND);
export const modalSetClosed = createAction(MODAL_SET_CLOSED);
export const modalSelectItem = createAction(MODAL_SELECT_ITEM);
export const modalInputEhrPatientId = createAction(MODAL_INPUT_EHR_PATIENT_ID);

export const modalTriggerNotFound = createAction(MODAL_TRIGGER_NOT_FOUND);
export const modalClean = createAction(MODAL_CLEAN);

export const ehrSyncLastUpdated = createAction(SYNC_LAST_UPDATED);
export const ehrSyncManualAll = createAction(SYNC_MANUAL_ALL);
export const ehrSyncManualItems = createAction(SYNC_MANUAL_ITEMS);
export const ehrSyncManualItemsFinish = createAction(SYNC_MANUAL_ITEMS_FINISH);
